import { FC } from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";
import { formatAmount } from "../../../../utils/numbers/money";

type Props = {
  label: string;
  amount: number;
  currency: string;
  hint?: string;
};

const styles = StyleSheet.create({
  wrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: 8,
    flexShrink: 1,
  },
  label: {
    color: "#0e1227",
    fontWeight: 600,
    fontSize: 9,
  },
  value: {
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    flexGrow: 1,
  },
  integerValue: {
    fontFamily: "SourceSerifPro",
    fontStyle: "normal",
    fontWeight: 400,
    fontSize: 20,
    color: "#0b0e1e",
  },
  decimalValue: {
    fontFamily: "SourceSerifPro",
    fontWeight: 400,
    fontSize: 16,
    color: "#0b0e1e",
  },
  hint: {
    fontFamily: "Manrope",
    fontSize: 10,
    color: "#666a84",
    fontWeight: 600,
  },
});

export const SummaryBox: FC<Props> = ({ label, amount, currency, hint }) => {
  const strAmount = formatAmount(amount);
  const [integer, decimal] = strAmount.split(".");

  return (
    <View style={styles.wrapper}>
      <Text style={styles.label}>{label}</Text>

      <View style={styles.value}>
        <Text style={styles.integerValue}>
          {currency.toUpperCase()} {`${integer}.`}
          <Text style={styles.decimalValue}>{decimal}</Text>
        </Text>
      </View>

      {hint && <Text style={styles.hint}>{hint}</Text>}
    </View>
  );
};
